function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import tw from "tailwind-styled-components";
import { SButton, SIcon, SIconType } from "../components";
import Icon from "../icons";
const Container = tw.div`
  relative
  text-md
`;
const FakeButton = tw.button`
  inline-flex
  justify-center
  items-center
  gap-1
  transition-all
  rounded-md
  text-accent-light

  hover:bg-opacity-7

  ${({ $isButtonStyle })=>$isButtonStyle ? `
    p-[10px]
    bg-brand-primary
    bg-opacity-10
  ` : ""}
`;
const SizeStyles = {
    sm: "text-[11px]",
    md: "text-sm",
    lg: "text-base",
    xl: "text-lg"
};
export const FileUploader = ({ ariaLabel = "upload", handleFile, hasError = false, handleRetry, accept = "image/*", hideText = false, hideIcon = false, isButtonStyle = false, size = "md", buttonSize = "md", customSize = "", isSuiButton = false, suiButtonProps = {}, buttonChildren, disabled = false, isLoading = false })=>{
    const hiddenFileInput = useRef(null);
    const sizeStyles = SizeStyles[size];
    const handleClick = (e)=>{
        e.preventDefault();
        if (hiddenFileInput && hiddenFileInput.current) {
            hiddenFileInput.current.click();
        }
    };
    const handleChange = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(e) {
            e.preventDefault();
            const target = e === null || e === void 0 ? void 0 : e.target;
            if ((target === null || target === void 0 ? void 0 : target.files) && (target === null || target === void 0 ? void 0 : target.files[0])) {
                yield handleFile(target.files[0]);
                if (hiddenFileInput && (hiddenFileInput === null || hiddenFileInput === void 0 ? void 0 : hiddenFileInput.current)) {
                    hiddenFileInput.current.value = "";
                }
            }
        });
        return function handleChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    const onClickButton = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*(e) {
            e.preventDefault();
            if (isLoading) return;
            if (hasError) {
                handleRetry(e);
            } else {
                handleClick(e);
            }
        });
        return function onClickButton(e) {
            return _ref.apply(this, arguments);
        };
    }();
    const _text = hideText ? "" : hasError ? "Retry" : "Upload";
    const text = buttonChildren && !hasError ? buttonChildren : _text;
    const widthAndHeight = customSize ? {
        width: customSize,
        height: customSize
    } : {};
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            isSuiButton ? /*#__PURE__*/ _jsxs(SButton, _object_spread_props(_object_spread({
                disabled: disabled || isLoading,
                onClick: onClickButton,
                size: buttonSize
            }, suiButtonProps), {
                children: [
                    text,
                    !hideIcon && /*#__PURE__*/ _jsx(_Fragment, {
                        children: hasError ? /*#__PURE__*/ _jsx(Icon, {
                            name: "MdRefresh",
                            size: "lg"
                        }) : isLoading ? /*#__PURE__*/ _jsx(SIcon, {
                            type: "spinner",
                            className: "animate-spin",
                            size: 16
                        }) : // <Icon name="MdOutlineFileUpload" size="lg" />
                        /*#__PURE__*/ _jsx(SIcon, {
                            size: 16,
                            type: SIconType.Upload
                        })
                    })
                ]
            })) : /*#__PURE__*/ _jsxs(FakeButton, {
                disabled: disabled || isLoading,
                onClick: onClickButton,
                $isButtonStyle: isButtonStyle,
                className: `${sizeStyles}`,
                style: widthAndHeight,
                children: [
                    text,
                    !hideIcon && /*#__PURE__*/ _jsx(_Fragment, {
                        children: hasError ? /*#__PURE__*/ _jsx(Icon, {
                            name: "MdRefresh",
                            size: "lg"
                        }) : isLoading ? /*#__PURE__*/ _jsx(SIcon, {
                            type: "spinner",
                            className: "animate-spin",
                            size: 16
                        }) : /*#__PURE__*/ _jsx(Icon, {
                            name: "MdOutlineFileUpload",
                            size: "lg"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("input", {
                type: "file",
                ref: hiddenFileInput,
                onChange: handleChange,
                style: {
                    display: "none"
                },
                accept: accept,
                "aria-label": ariaLabel
            })
        ]
    });
};
